/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Chat_Browser_Confirm_TargetInputs */



/**
* | output |
* | --- |
* | "Target: {url}" |
*
* @param {Chat_Browser_Confirm_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_browser_confirm_target = /** @type {((inputs: Chat_Browser_Confirm_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Browser_Confirm_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ziel: ${i?.url}`)
	return /** @type {LocalizedString} */ (`Target: ${i?.url}`)
});